import "./TablesCards.css"
import TableCard from "../TableCard/TableCard"
import { useRestaurantDarwer } from "../../detail/hooks/drawer"
import { RootState } from "src/store/store"
import { useSelector } from "react-redux"
import { ToggleFlagProvider } from "src/shared/hooks/useToggleFlag"

const TablesCards = () => {
    const { onOpen, setMesa, onStopLoading } = useRestaurantDarwer()
    const { mesas, tablesDimensions } = useSelector((root: RootState) => root.restaurant)

    return (
        <div className="tables-cards__wrapper scrollbar__light-fat">
            <ToggleFlagProvider>
                <div
                    className="tables-cards"
                    style={{
                        gridTemplate: `repeat(${tablesDimensions?.x}, 1fr) / repeat(${tablesDimensions?.y}, 1fr)`,
                    }}
                    data-testid={"mesas-container"}
                >
                    {mesas?.map((mesa, index) => (
                        <TableCard
                            testId={`mesa-${index}`}
                            style={{
                                gridArea: `${mesa?.posicion?.y}/ ${mesa?.posicion?.x} / span 1 / span 1`,
                            }}
                            key={index}
                            onSelect={() => {
                                onOpen()
                                setMesa(mesa)
                                onStopLoading()
                            }}
                            mesa={mesa}
                        />
                    ))}
                </div>
            </ToggleFlagProvider>
        </div>
    )
}

export default TablesCards
